import { MoveUp } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const MoveUpIcon = createLucideIcon(MoveUp);
